import React from "react";
import { fetchMyAgenda } from "../../methods/agenda/agendaRequests";
import AgendaSummaryView from "../../components/agenda/AgendaSummaryView";

export default function MyAgendaPage() {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [agenda, setAgenda] = React.useState({ summary: null, items: [] });

  const loadAgenda = React.useCallback(async () => {
    setLoading(true);
    setError("");

    const response = await fetchMyAgenda();

    if (!response?.success) {
      setAgenda({ summary: null, items: [] });
      setError(response?.error || "Failed to load agenda.");
      setLoading(false);
      return;
    }

    setAgenda({
      summary: response.data?.summary || null,
      items: Array.isArray(response.data?.items) ? response.data.items : [],
    });
    setLoading(false);
  }, []);

  React.useEffect(() => {
    loadAgenda();
  }, [loadAgenda]);

  return (
    <AgendaSummaryView
      title="My Agenda"
      subtitle="View your appointments, class bookings, and other scheduled activity in one place."
      loading={loading}
      error={error}
      agenda={agenda}
      onRefresh={loadAgenda}
    />
  );
}
